import { useEditor } from "@craftjs/core"

export default function useSelectedProperties() {
  const { Properties } = useEditor(({ events, nodes }) => {
    const [id] = events.selected

    if (!id || id === 'ROOT') {
      return {}
    }

    return { Properties: nodes[id]?.related?.Properties }
  })

  return Properties
}
